import {
  JOB_TIME_ENTRY_REPORT_REQUEST,
  JOB_TIME_ENTRY_REPORT_SUCCESS,
  JOB_TIME_ENTRY_REPORT_FAIL,
} from "./actionType";

const initialState = {
  jobTimeEntryReportSummary: null,
  jobTimeEntryReportPeriods: [],
  jobTimeEntryReportLoading: false,
  jobTimeEntryReportError: null,
};

const JobTimeEntryReport = (state = initialState, action) => {
  switch (action.type) {
    case JOB_TIME_ENTRY_REPORT_REQUEST:
      return {
        ...state,
        jobTimeEntryReportLoading: true,
        jobTimeEntryReportError: null,
      };

    case JOB_TIME_ENTRY_REPORT_SUCCESS:
      return {
        ...state,
        jobTimeEntryReportLoading: false,
        jobTimeEntryReportSummary: action.payload?.summary || null,
        jobTimeEntryReportPeriods: action.payload?.reportperiods_list || [],
      };

    case JOB_TIME_ENTRY_REPORT_FAIL:
      return {
        ...state,
        jobTimeEntryReportLoading: false,
        jobTimeEntryReportError: action.payload,
      };

    default:
      return state;
  }
};

export default JobTimeEntryReport;
